{
  "wallboard": {
    "instances_count": "no hay instancias | {count} instancia | {count} instancias",
    "label": "Tablero"
  }
}
